<template>
  <VCol
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg"
    :xl="xl"
    :xxl="xxl"
    :order="order"
    :order-sm="orderSm"
    :order-md="orderMd"
    :order-lg="orderLg"
    :order-xl="orderXl"
    :order-xxl="orderXxl"
    :style="{ width: `${width}px` }"
    :class="{ 'v-col-basis-auto': flexBasisAuto }"
  >
    <slot />
  </VCol>
</template>

<script setup lang="ts">
import { VCol } from 'vuetify/components/VGrid';

export interface Props {
  cols?: string | number | boolean;
  sm?: boolean | string | number;
  md?: boolean | string | number;
  lg?: boolean | string | number;
  xl?: boolean | string | number;
  xxl?: boolean | string | number;
  order?: string | number;
  orderSm?: string | number;
  orderMd?: string | number;
  orderLg?: string | number;
  orderXl?: string | number;
  orderXxl?: string | number;
  width?: number;
  flexBasisAuto?: boolean;
}

withDefaults(defineProps<Props>(), {
  flexBasisAuto: false,
  cols: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined,
  xxl: undefined,
  order: undefined,
  orderSm: undefined,
  orderMd: undefined,
  orderLg: undefined,
  orderXl: undefined,
  orderXxl: undefined,
  width: undefined,
});
</script>

<style lang="scss" scoped>
.v-col-basis-auto {
  flex-basis: auto;
}
</style>
